import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-student-atd',
  templateUrl: './student-atd.component.html',
  styleUrls: ['./student-atd.component.scss']
})
export class StudentAtdComponent implements OnInit {
  AttendanceForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: [];
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  ForCsv: any;
  Student: any;
  errMsg: any;
  saveDisable = false
  updateDisable = false
  currentDate: Date;
  // jsonData: any;
  examList
  filteredListExam
  subjectList = []
  filteredsubjectList
  isBranch = false;
  attendance = 0
  BranchList
  filteredListBranch
  emid
  subcode
  savedpayload: any;
  SubAtdList: any;
  IsFile = false;
  submit = false
  AttendCounts: any;
  UserCollege
userPermission
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,

  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.SaveBtn = false;
    this.submit = false
    this.UpdateBtn = false;
    this.Table = false
    this.IsFile = false;
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    this.attendance = 0
    let id = ''
    this.submitButton = true;
    this.editButton = false;
    this.AttendanceForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      EmId: new FormControl(''),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),
      StuArray: new FormArray([]),
    });
    this.fetchSession(id);
    this.getClg();
    this.currentDate = new Date();
  }

  getStuArrayControls() {
    return (this.AttendanceForm.get('StuArray') as FormArray).controls;
  }



  fetchSession(id) {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  getCourse(id) {
    let payload2 = this.AttendanceForm.value
    this.Table = false
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.isBranch = false;
    this.IsFile = false;
    this.AttendanceForm.controls['course'].setValue('');
    this.AttendanceForm.controls['EmId'].setValue('');
    this.AttendanceForm.controls['Branch'].setValue('');
    this.AttendanceForm.controls['EsId'].setValue('');
    this.filteredListCourse = [];
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    this.examList = [];
    this.BranchList = [];
    this.subjectList = [];
    this.CourseList = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = id;
    // payload['SessionId'] = payload2.SessionId;

    // getSessionColgCo
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getClg() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.Table = false;
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }

  ShowTable() {
    this.spinner.show()
    this.Table = false;
    let payload2 = this.AttendanceForm.value
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [''];
    this.StudentTable = [];
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['CgCode'] = payload2.college;
    payload['EsCode'] = this.subcode;
    payload['EmId'] = payload2.EmId;
    this.umsService.getStdAtdList(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.assignTableData = [''];
        this.Table = true;
        this.assignTableData = res.data;
        if (this.assignTableData[0]['AttendCount'] == null && this.assignTableData[0]['AttendStatus'] == null) {
          this.SaveBtn = true;
          this.UpdateBtn = false;
          // this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
          // this.StuArray['Status'].setValue('Y');
        }
        else {
          this.SaveBtn = false;
          this.UpdateBtn = true;
        }
        this.assignTableData.forEach((element, i) => {
          const creds = this.AttendanceForm.get('StuArray') as FormArray;
          // creds.clear();
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              Name: new FormControl(element['StudentFullName']),
              Attendance: new FormControl(element['AttendCount'], [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
              Status: new FormControl(element['AttendStatus']),
              StuId: new FormControl(element['StuId']),
              SctId: new FormControl(element['ScrutinyId'])
            })
          );
        });
        this.getStuAtdSet()

      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          this.getNewStu()
          // this.StudentTable = [];
          // this.Table = false;
          // this.SaveBtn = false;
          // this.UpdateBtn = false;
          // let data = {}
          // data['message'] = 'No Data Found For This Filter'
          // data['title'] = 'Alert'
          // data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      }

    });

  }

  getNewStu() {
    this.spinner.show()
    this.Table = false;
    let payload2 = this.AttendanceForm.value
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [''];
    this.StudentTable = [];
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SnNo'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['EmId'] = payload2.EmId;
    payload['EsCode'] = this.subcode;
    payload['CgCode'] = payload2.college;
    this.umsService.NewSemStuAtd(payload).subscribe((res) => {
     
      if (res.status) {
         this.spinner.hide();
        this.assignTableData = [''];
        this.Table = true;
        this.assignTableData = res.data[0];
        if (this.assignTableData[0]['AttendCount'] == null && this.assignTableData[0]['AttendStatus'] == null) {
          this.SaveBtn = true;
          this.UpdateBtn = false;
          // this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
          // this.StuArray['Status'].setValue('Y');
        }
        else {
          this.SaveBtn = false;
          this.UpdateBtn = true;
        }
        this.assignTableData.forEach((element, i) => {
          const creds = this.AttendanceForm.get('StuArray') as FormArray;
          // this.ForCsv = element.push(this.ForCsv)

          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              Name: new FormControl(element['StudentFullName']),
              Attendance: new FormControl(element['AttendCount'], [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
              Status: new FormControl(element['AttendStatus']),
              StuId: new FormControl(element['StuId']),
              SctId: new FormControl(element['ScrutinyId'])
            })
          );
        });
        this.getStuAtdSet()

      } else {
         this.spinner.hide();
        if (res.message == 'No Data Found') {
          this.StudentTable = [];
          this.Table = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          let data = {}
          data['message'] = 'No Data Found For This Filter'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.StudentTable = [];
      this.Table = false;
      this.SaveBtn = false;
      this.UpdateBtn = false;
      let data = {}
      data['message'] = 'No Data Found For This Filter'
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });

  }

  addNewRow() {
    const creds = this.AttendanceForm.controls.StuArray as FormArray;
    creds.push(
      this.fb.group({
        SrNo: new FormControl(''),
        Name: new FormControl(''),
        Attendance: new FormControl('', [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
        Status: new FormControl('N'),
        StuId: new FormControl(''),
        SctId: new FormControl('')
      })
    );
  }

  onInputChange2(val, i) {
    this.saveDisable = false
    this.updateDisable = false
    const tempData = val.target.value;
    let taskListArrays = this.AttendanceForm.get('StuArray') as FormArray;
    console.log('tempData',tempData);
    
    if (tempData > 100) {
      console.log('attendance greater than 100');
      if (this.SaveBtn == true) {
        this.saveDisable = true
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = true
      }
    }
    else {
      if (this.SaveBtn == true) {
        this.saveDisable = false
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = false
      }
    }
    if (tempData == '') {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }

    let data = this.SubAtdList.find(item => item.EsCode === this.subcode);

    if (tempData >= data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    if (tempData > data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    if (tempData == data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    else if (tempData < data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }

  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.max
  }

  Save() {
    if (this.AttendanceForm.invalid) {
      this.AttendanceForm.get('college').markAsTouched();
      this.AttendanceForm.get('course').markAsTouched();
      this.AttendanceForm.get('SessionId').markAsTouched();
      this.AttendanceForm.get('EmId').markAsTouched();
      this.AttendanceForm.get('SubCode').markAsTouched();
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
        return
      }
      return
    }
    else {
      this.SaveAtd()
      return
    }
  }

  SaveAtd() {
    this.spinner.show();
    this.submitpayload = this.AttendanceForm.value;
    this.AttendanceForm.controls.StuArray as FormArray;
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    // let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionID'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['college'];
        payload['CoCode'] = this.submitpayload['course'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['EsId'] = this.submitpayload['EsId'];
        payload['SubCode'] = this.subcode;
        payload['Branch'] = this.submitpayload['Branch'];
        payload['StuID'] = element.StuId;
        payload['AttendCount'] = parseInt(element.Attendance) ? parseInt(element.Attendance) : '';
        payload['AttendStatus'] = element.Status ? element.Status : '';
        payload['ScrutinyID'] = element.SctId;
        payload['UserID'] = sessionStorage.getItem('userId');
        payload['EntryDateTime'] = this.currentDate;
        this.umsService.saveStdAtd(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
      }
    });
  }

  update() {
    if (this.AttendanceForm.invalid) {
      console.log('invalid form',this.AttendanceForm);
      
      this.AttendanceForm.get('college').markAsTouched();
      this.AttendanceForm.get('course').markAsTouched();
      this.AttendanceForm.get('SessionId').markAsTouched();
      this.AttendanceForm.get('EmId').markAsTouched();
      this.AttendanceForm.get('SubCode').markAsTouched();
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
      }
    }
    else {
      this.updateAtd()
    }
  }

  updateAtd() {
    // updateStdAtd
    this.spinner.show();
    this.submitpayload = this.AttendanceForm.value;
    this.AttendanceForm.controls.StuArray as FormArray;
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionID'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['college'];
        payload['CoCode'] = this.submitpayload['course'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['EsId'] = this.submitpayload['EsId'];
        payload['SubCode'] = this.subcode;
        payload['Branch'] = this.submitpayload['Branch'];
        payload['StuID'] = element.StuId;
        payload['AttendCount'] = parseInt(element.Attendance);
        payload['AttendStatus'] = element.Status;
        payload['ScrutinyID'] = element.SctId;
        payload['UserID'] = sessionStorage.getItem('userId');
        payload['EntryDateTime'] = this.currentDate;
        this.umsService.updateStdAtd(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
      }
    });
  }



  getExamList(e) {
    this.IsFile = false;
    this.spinner.show();
    this.Table = false;
    this.filteredsubjectList = [];
    this.AttendanceForm.controls['EmId'].setValue('');
    this.AttendanceForm.controls['Branch'].setValue('');
    this.AttendanceForm.controls['EsId'].setValue('');
    this.examList = [];
    this.BranchList = [];
    this.subjectList = [];
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = e;
    this.filteredsubjectList = [];
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }



  getSubject(e) {
    this.IsFile = false;
    this.spinner.show();
    this.Table = false;
    this.isBranch = false;
    this.AttendanceForm.controls['Branch'].setValue('');
    this.AttendanceForm.controls['EsId'].setValue('');
    this.BranchList = [];
    this.subjectList = [];
    this.filteredsubjectList = []
    this.emid = e.EmId;
    if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
    } else {
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();
        res.data.children.forEach(element => {

          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      });
    }

  }


  fetchBranch(id) {
    this.Table = false;
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = []
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }


  getStr(e) {
    this.Table = false;
    this.IsFile = false;
    this.AttendanceForm.controls['EsId'].setValue('');
    this.subjectList = [];
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = e.StrId;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      res.data.children.forEach(element => {
        if (element.EsType == 'S') {
          this.subjectList.push(element)
        }
        else if (element.EsType == 'G') {
          element.children.forEach(grpSub => {
            this.subjectList.push(grpSub)
          });
        }
        this.filteredsubjectList = this.subjectList.slice();
      });
    });
  }

  subjectClick(item) {
    this.subcode = item.EsCode;
    this.IsFile = true;
  }

  getStuAtdSet() {
    this.spinner.show();
    this.savedpayload = this.AttendanceForm.value
    this.SubAtdList = []
    this.attendance = 0
    const payload = {};
    payload['CgCode'] = this.savedpayload.college;
    payload['CoCode'] = this.savedpayload.course;
    payload['EmId'] = this.savedpayload.EmId;
    payload['StrId'] = this.savedpayload.Branch;
    payload['SessionId'] = this.savedpayload.SessionId;
    this.umsService.getStuAtdSet(payload).subscribe(res => {

      if (res.status) {
        this.spinner.hide();
        this.SubAtdList = res.data;
        let data = this.SubAtdList.find(item => item.EsCode === this.subcode);
        if (data.Attendance == null) {
          let data = {}
          data['message'] = 'Subject Attendance Threshold Not Entered For This Subject.'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.saveDisable = true
          this.updateDisable = true
          this.submit = false;
        }
        else {
          this.saveDisable = false;
          this.attendance = data.Attendance
          this.submit = true
          // this.UpdateBtn = false
        }

      }
      else {
        let data = {}
        data['message'] = 'Subject Attendance Not Entered For This Subject.'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.SaveBtn = false;
        this.UpdateBtn = false;
        this.saveDisable = true;
        this.submit = false;
        this.spinner.hide();
      }



    });
  }



  File(event: any) {

    const data = {};
    data['message'] = 'Do You Want To Upload This File ?';
    data['title'] = 'Information';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.dialogRef.close();
        const files: FileList = event.target.files;
        const allowedExtensions = ['csv'];

        if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            const file: File = files[i];
            const extension = file.name.split('.').pop().toLowerCase();

            if (allowedExtensions.includes(extension)) {
              // Process the selected file here (e.g., read its content or upload it)
              // let data = {};
              // data['message'] = 'File Uploaded Successfully';
              // data['title'] = 'Information';
              // data['icon'] = 'fas fa-check';
              // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
              //   AlertBoxComponent,
              //   data
              // );
   
              // this.SearchEditMarks();
              // this.ControlLock2(parseInt(this.LoginId));
              this.getTextFromFile(file);

            }
          }
        }
      }
      else {
        this.dialogRef.close();
      }
    });




  }

  importDataFromCSV(csvText: string): Array<any> {
    const propertyNames = csvText.slice(0, csvText.indexOf('\n')).split(',');
    const dataRows = csvText.slice(csvText.indexOf('\n') + 1).split('\n');
    let dataArray: any[] = [];
    dataRows.forEach((row) => {
      let values = row.split(',');
      let obj: any = new Object();
      for (let index = 0; index < propertyNames.length; index++) {
        const propertyName: string = propertyNames[index];
        let val: any = values[index];
        if (val === '') {
          val = parseInt;
        }
        obj[propertyName] = val;
      }
      dataArray.push(obj);
    });
    return dataArray;
  }

  async getTextFromFile(file) {
    // const file: File = event.target.files[0];
    let fileContent = await file.text();
    const importedData = this.importDataFromCSV(fileContent);
    this.processCsvContents(importedData.slice(0, importedData.length - 1));
  }
  ///
  processCsvContents(dataArray): void {
    this.spinner.show()
    let AttendanceCounttt = this.attendance
     let iserror = false;
     var bar = new Promise<void>((resolve, reject) => {
    dataArray.forEach((element, index, array) => {
      const userId: string | null = sessionStorage.getItem('userId');
      const entryDateTime: Date = this.currentDate;
      let student = this.StuArray.value;
      let attEsId = this.SubAtdList[0]
      element.CoCode = this.AttendanceForm.value.course;
      element.SubCode = this.subcode
      element.EsId = this.AttendanceForm.value['EsId'];
      element.EmId = attEsId.EmId;
      element.SessionID = this.AttendanceForm.value.SessionId;
      element.UserID = userId;
      element.EntryDateTime = entryDateTime;
      element.CgCode = this.AttendanceForm.value.college;
      element['AttendCount'] = parseInt(element['AttendCount']);
      this.AttendCounts = this.assignTableData[0]['AttendCount'];
      this.assignTableData[0]['AttendCount']
      if (AttendanceCounttt == parseInt(element['AttendCount']) || parseInt(element['AttendCount']) > AttendanceCounttt) {
        element['AttendStatus'] = 'Y'
      }
      else {
        element['AttendStatus'] = 'N'
      }
      if (this.AttendCounts == '' || this.assignTableData[0]['AttendCount'] == null) {
        this.umsService.saveStdAtd(element).subscribe((res) => {
        if (res.status == false) {
          iserror = true;
          this.errMsg = res.message
        }
        if (index === array.length - 1) resolve();
        else {
          iserror = false
          this.errMsg = res.message
         
        }
        },(ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          
        });
      } else {
        this.umsService.updateStdAtd(element).subscribe((res) => {
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            this.ngOnInit()
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
         
        });
      }

    });
  })
  bar.then(() => {
    if (iserror == false) {
      this.spinner.hide();
      let data = {}
      data['message'] = "Upload Successfully"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.ShowTable2()
      });

    } else {
      let data = {}
      data['message'] = this.errMsg
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        // this.ShowTable()
      });
    }
  });
  }


  download2(event: Event) {
    event.preventDefault();
    const extractedData = this.assignTableData.map(element => ({
      StuID: element.StuId,
      Name: element.StudentFullName,
      AttendCount: element.AttendCount,
      // AttendStatus: element.AttendStatus,
      ScrutinyID: 0,
      Branch :element.EsStrId,
      // Add more fields as needed
    }));

    // Convert array data to CSV format
    const csvContent = this.convertArrayToCSV(extractedData);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.csv'; // You can change the file name if needed
    document.body.appendChild(link);

    // Trigger the download
    link.click();
  }

  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }


  ShowTable2() {
    this.spinner.show()
    this.Table = false;
    let payload2 = this.AttendanceForm.value
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [];
    this.StudentTable = [];
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['CgCode'] = payload2.college;
    payload['EsCode'] = this.subcode;
    payload['EmId'] = payload2.EmId;
    this.umsService.getStdAtdList(payload).subscribe((res) => {
      
      if (res.status) {
        this.spinner.hide();
        this.assignTableData = [];
        this.Table = true;
        this.assignTableData = res.data;
        if (this.assignTableData[0]['AttendCount'] == null && this.assignTableData[0]['AttendStatus'] == null) {
          this.SaveBtn = true;
          this.UpdateBtn = false;
          // this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
          // this.StuArray['Status'].setValue('Y');
        }
        else {
          this.SaveBtn = false;
          this.UpdateBtn = true;
        }
        this.assignTableData.forEach((element, i) => {
          const creds = this.AttendanceForm.get('StuArray') as FormArray;
          // creds.clear();
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              Name: new FormControl(element['StudentFullName']),
              Attendance: new FormControl(element['AttendCount'], [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
              Status: new FormControl(element['AttendStatus']),
              StuId: new FormControl(element['StuId']),
              SctId: new FormControl(element['ScrutinyId'])
            })
          );
        });
        this.getStuAtdSet()

      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          this.getNewStu()
          // this.StudentTable = [];
          // this.Table = false;
          // this.SaveBtn = false;
          // this.UpdateBtn = false;
          // let data = {}
          // data['message'] = 'No Data Found For This Filter'
          // data['title'] = 'Alert'
          // data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      }

    });

  }
}
